import { getQueryStrings } from './querystring-utils';
export const isReferrer = (referrer) => {
    const queryStrings = getQueryStrings();
    return queryStrings && queryStrings.referrer === referrer;
};
